(function ($, DGS) {
  DGS.OnLoad.getInstance().register(function () {
    var buildDictionaryPostHeader = function buildDictionaryPostHeader() {
      var categories = document.querySelector(".blog-categories");
      var blog = document.querySelector(".blog");
      var blogTitle = blog.querySelector(".blog-title");
      var blogImage = blog.querySelector(".blog-image");
      blogImage.querySelector("img").width = "1920";
      blogImage.querySelector("img").height = "500";
      blogImage.querySelector("img").alt = blogTitle.innerText;
      blog.insertBefore(categories, blog.querySelector(".component-content"));
    };
    if (document.querySelector(".dictionary-post")) {
      buildDictionaryPostHeader();
    }
  });
})(jQuery, window.DGS);